// extracted by mini-css-extract-plugin
module.exports = {"header":"header--pLBWA","block":"block--2qQJP","block-title":"block-title--3D9Vn","btn-line":"btn-line--1-Jdg"};